import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.parse-int.js";
import "regenerator-runtime/runtime.js";
import { getBoylikegirlClubMarketsForExchangeUVF, getAllBoylikegirlClubTotalPoints } from "../apis/services/steemActivity";
import { exchangeUVFWithUserNameAndPassword, exchangeUVFWithSteemKeychain } from "../unit/boylikegirlcluboperUtil";
import { extractLoginData } from "../unit/UserUtil";
import MarketList from "../components/MarketList.vue";
import { ElMessage, ElLoading } from "element-plus";
export default {
  components: {
    MarketList: MarketList
  },
  data: function data() {
    return {
      market: {},
      points: 0,
      loginData: null,
      exchangeNum: 0,
      isLogining: false,
      marketId: 0
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

                if (_this.loginData) {
                  _this.isLogin = true;
                  account = _this.loginData[0];
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exchange: function exchange() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var totalPoints, account, isUseSteemKeychain, password;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLogining = true;

                if (_this2.loginData) {
                  _context2.next = 5;
                  break;
                }

                _this2.isLogining = false;

                _this2.$bus.emit("openLogin");

                return _context2.abrupt("return");

              case 5:
                _this2.exchangeNum = parseInt(_this2.exchangeNum);

                if (_this2.exchangeNum) {
                  _context2.next = 10;
                  break;
                }

                _this2.isLogining = false;
                ElMessage.error(_this2.$t("error.exchangeNumError"));
                return _context2.abrupt("return");

              case 10:
                totalPoints = _this2.exchangeNum * _this2.market.exchangeFee;

                if (!(totalPoints > _this2.points)) {
                  _context2.next = 15;
                  break;
                }

                _this2.isLogining = false;
                ElMessage.error(_this2.$t("error.balanceError"));
                return _context2.abrupt("return");

              case 15:
                if (!_this2.loginData) {
                  _context2.next = 26;
                  break;
                }

                account = _this2.loginData[0];
                isUseSteemKeychain = _this2.loginData[4];
                password = _this2.loginData[1];

                if (!isUseSteemKeychain) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 22;
                return exchangeUVFWithSteemKeychain(account, _this2.exchangeNum, _this2.marketId, _this2.exchangeCallback);

              case 22:
                _context2.next = 26;
                break;

              case 24:
                _context2.next = 26;
                return exchangeUVFWithUserNameAndPassword(account, password, _this2.exchangeNum, _this2.marketId, _this2.exchangeCallback);

              case 26:
                _this2.isLogining = false;

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exchangeCallback: function exchangeCallback(result) {
      var _this3 = this;

      if (result.code == 0) {
        ElMessage({
          message: this.$t("success." + result.message),
          type: "success"
        });
      } else {
        ElMessage.error(this.$t("error." + result.message));
      }

      getAllBoylikegirlClubTotalPoints(this.currentUserName).then(function (res) {
        _this3.points = res.data;
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.loadAccount();

            case 2:
              if (_this4.loginData) {
                _this4.currentUserName = _this4.loginData[0];
              }

              _this4.marketId = _this4.$route.params.id;
              _context3.next = 6;
              return getBoylikegirlClubMarketsForExchangeUVF(_this4.marketId);

            case 6:
              _this4.market = _context3.sent.data;

              if (_this4.currentUserName) {
                getAllBoylikegirlClubTotalPoints(_this4.currentUserName).then(function (res) {
                  _this4.points = res.data;
                });
              }

              _this4.$bus.on("loginScuccess", function () {
                _this4.loadAccount();
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};